<template>
  <Table
    v-if="!loading"
    :loading="loading"
    width="100%"
    height="500"
    border
    :columns="columns"
    :data="attData"
    size="small"
    ref="table"
  >
    <template slot-scope="{ row }" slot="joinedAt">{{
      row.watchStarted | moment("HH:mm:ss")
    }}</template>
    <template slot-scope="{ row }" slot="action">
      <!--
      <Button icon="ios-close" shape="circle" @click="removeParticipant(row)"></Button>
      -->
    </template>
  </Table>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import $config from '@/config'
import { mapState, mapGetters, mapActions } from 'vuex'
import { database, db } from '@/firebase'
import _ from 'lodash'

export default {
  data() {
    return {
      loading: true,
      data: {},
      columns: []
    }
  },
  computed: {
    ...mapGetters('webcast', {
      event: 'getCopy'
    }),
    attData() {
      let data = []
      _.forEach(this.$parent.webcastUserList, (value, key) => {
        if (value.info) {
          _.forEach(value.info, (val, key) => {
            value[key] = val
          })
        }
        data.push(value)
        console.log(data)
      })
      return data
    }
  },
  methods: {},
  async created() {
    const regFormRef = db.collection(
      `/event/${this.event.newWebcastId}/regForm`
    )

    const snapshot = await regFormRef.get()

    snapshot.forEach(doc => {
      let regFormData = doc.data()
      if (regFormData.is_shown && regFormData.type !== 'html_content') {
        this.columns.push({
          title: _.capitalize(regFormData.name),
          key: _.kebabCase(regFormData.name),
          width: 160
        })
      }
    })

    console.log(this.columns)

    this.loading = false

    /*
    this.$store.commit("session-connections/clearAll");
    this.findParticipantsAction({
      query: {
        webcastId: this.webcast._id
        //updatedAt: { $gte: moment(new Date()).subtract(1, "minutes").toDate().toISOString()}
      }
    }).then(res => {
      this.findRegFormAction({ query: { webcastId: this.webcast._id } }).then(
        response => {
          _.forEach(response.data, (row, key) => {
            this.columns.push({
              title: _.capitalize(row.name),
              key: _.kebabCase(row.name),
              width: 160
            });
          });

          this.columns.push({
            title: "Started to Watch",
            slot: "joinedAt",
            width: 160,
            align: "center"
          });

          this.columns.push({
            title: "Actions",
            slot: "action",
            width: 100,
            align: "right"
          });
        }
      );
      this.loading = false;
    });
    */
  }
}
</script>

<style>
</style>
